var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.99,
  d: "M12.778 3.422V1.668m0 1.754v1.755m0-1.755H8.61M1.666 8.686v-3.51c0-.465.196-.91.543-1.24a1.9 1.9 0 0 1 1.31-.514H5.37m0-1.754v3.509m12.963 3.509v-3.51c0-.465-.195-.91-.542-1.24a1.9 1.9 0 0 0-1.31-.514h-.463M1.666 8.686v7.894c0 .466.196.912.543 1.24.347.33.818.515 1.31.515H16.48c.491 0 .962-.185 1.31-.514.347-.33.542-.776.542-1.24V8.685z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
export default SvgCalendar;